import * as React from 'react';
import { ServiceView } from 'elc-service';
import { CONTENT_BLOCK } from 'elc-service-view-names';

export interface IProductContent {
    nid: number;
}

export const ProductContent = (props: IProductContent) => (
    <ServiceView
        name={CONTENT_BLOCK}
        config={{
            nid: props.nid
        }}
    />
);
